<template>
  <span>
    <add-from-stock @row-click="addRowsIn($event)" />
    <span class="btn btn-outline-dark mr-1"
      >Rendimiento: {{ percentage(totalSaleable, totalInNet) }}%</span
    >
    <span class="btn btn-outline-dark mr-1"
      >Merma: {{ percentage(totalWaste, totalInNet) }}%</span
    >
    <span class="btn btn-outline-dark mr-1"
      >Diferencia: {{ differenceNet }}</span
    >
    <span class="btn btn-outline-dark mr-1"
      >Lote en proceso: {{ currentLotInProcess }}</span
    >

    <barcode-scanner
      class="float-right"
      size="md"
      @on-scan="addRowsIn($event)"
    />
    <select-scale class="float-right" size="md" />
    <b-spinner
      v-if="loading"
      variant="dark"
      class="mr-1 mt-1 float-right"
      small
    />
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import AddFromStock from "./AddFromStock";
import BarcodeScanner from "../../BarcodeScanner";
import selectScale from "../../../views/reusable/selectScale";

export default {
  name: "MainButtons",
  components: {
    AddFromStock,
    selectScale,
    BarcodeScanner
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("bagnoProcessModule", [
      "totalInNet",
      "differenceNet",
      "currentLotInProcess",
      "totalSaleable",
      "totalQuantitySaleable",
      "totalWaste"
    ])
  },
  methods: {
    percentage(a, b) {
      return ((a / b) * 100).toFixed(2);
    },
    difference(a, b) {
      return (a - b).toFixed(2);
    },
    addRowsIn(e) {
      this.$emit("add-rows-in", e);
    }
  }
};
</script>

<style scoped></style>
